<template>
    <FilterBase :title>
        <div class="input-wrapper">
            <InputRangeTwoKnobbedWithInputs
                v-qa="'filter-price'"
                :disabled
                :max
                :min
                :model-value="priceRange"
                :value-formatter="formatter"
                :min-label
                :max-label
                @update:model-value="onUpdate"
            />
        </div>
    </FilterBase>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'

import type {
    CatalogueFilterPriceInput,
    FilterPriceRangeFragment,
} from '@/graphql/api'

import FilterBase from '@/components/ui/filter/filters/layout/FilterBase.vue'
import type {
    InputRangeModel,
    InputRangeTwoKnobbedValueFormatter,
} from '@/components/ui/inputs/range/input-range-two-knobbed-props.ts'
import InputRangeTwoKnobbedWithInputs from '@/components/ui/inputs/range/InputRangeTwoKnobbedWithInputs.vue'
import { useCurrencyInput } from '@/plugins/currency-input.ts'
import {
    type MoneyFormatter,
    useMoneyFormatter,
} from '@/plugins/money-formatter.ts'
import { useCountryPlugin } from '@/plugins/country.ts'

const props = defineProps<{
    filter: FilterPriceRangeFragment
    value: CatalogueFilterPriceInput | null | undefined
    disabled?: boolean
    formatter?: MoneyFormatter
    title?: string
    minLabel: string
    maxLabel: string
}>()

const emit = defineEmits<{
    'update': [InputRangeModel]
}>()

const max = computed(() => parseFloat(props.filter.currentRange.max.amount))
const min = computed(() => parseFloat(props.filter.currentRange.min.amount))

function parseModel(model: string | null | undefined): number | null {
    if (null === model || typeof model === 'undefined') {
        return null
    }

    const num = Number(model)

    if (isNaN(num)) {
        return null
    }

    return num
}

const priceRange = computed<InputRangeModel>(() => {
    const rangeMin = parseModel(props.value?.min)
    const rangeMax = parseModel(props.value?.max)

    // if (rangeMin === min.value || rangeMax === max.value) {
    //     return [null, null]
    // }

    return [rangeMin, rangeMax]
})

const { countryCode } = useCountryPlugin()
const currency = useCurrencyInput()

const onUpdate = (v: InputRangeModel) => {
    const normalized: InputRangeModel =
        v[0] === min.value && v[1] === max.value ? [null, null] : v

    emit('update', normalized)
}

const moneyFormatter = props.formatter ?? useMoneyFormatter()
const formatter = computed((): InputRangeTwoKnobbedValueFormatter => {
    return (value) => {
        return moneyFormatter({
            amount: value.toString(),
            currency: props.filter.currentRange.min.currency,
        })
    }
})

watch([currency, countryCode], () => {
    onUpdate([undefined, undefined])
})
</script>

<style lang="scss" scoped>
.input-wrapper {
    padding-left: 10px;
    padding-right: 10px;
}
</style>
